<template>
  <!-- 联系我们 — 联系方式 -->
  <div class="contact_container">
    <div class="contact_wrap">
      <div class="left_wrap">
        <div class="content">
          <div class="title_box">福建平潭瑞谦智能科技有限公司</div>
          <div class="text_wrap">
            <div class="label_box">联系方式：</div>
            <div class="text_box">400-8775178</div>
          </div>
          <div class="text_wrap">
            <div class="label_box">邮政编码：</div>
            <div class="text_box">350400</div>
          </div>
          <div class="text_wrap">
            <div class="label_box">电子邮箱：</div>
            <div class="text_box">rqzhineng@163.com</div>
          </div>
          <div class="text_wrap" style="margin-bottom: 20px">
            <div class="label_box">联系地址：</div>
            <div class="text_box">平潭综合实验区中山大道中段288号新兴产业园示范区1号楼1层</div>
          </div>
        </div>
      </div>
      <div class="right_wrap">
        <img :src="require('@/assets/img/contact/lingshiMap.png')" alt="">
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {

      }
    }
  }
</script>

<style scoped lang="scss">
.contact_container {
  width: 100%;
  height: 100%;
  padding-top: 4%;
  padding-bottom: 8%;
  color: rgb(33, 37, 41);
}
.contact_wrap {
  display: flex;
  flex-direction: row;
  width: 94%;
  max-width: 1280px;
  min-height: 300px;
  margin: 0 auto;
  background-color: rgba(245, 245, 245, 1);
  box-shadow: 0 0 10px rgba(0, 0, 0, .1);
  overflow: hidden;
  .left_wrap {
    display: flex;
    flex: 0 0 44%;
    .content {
      width: 100%;
      align-self: center;
      margin: auto;
      padding: 20px 50px;
      .title_box {
        margin-top: 15px;
        margin-bottom: 5%;
        font-size: 20px;
        font-weight: bold;
      }
      .text_wrap {
        display: flex;
        flex-direction: row;
        flex: 1;
        width: 100%;
        height: 26px;
        line-height: 26px;
        font-size: 14px;
        color: rgba(51, 51, 51, 1);
      }
    }
  }
  .right_wrap {
    flex: 0 0 56%;
    height: 380px ;
    background-color: rgba(245, 245, 200, 1);
    img {
      width: 100%;
    }
  }
}
@media screen and (max-width: 768px) {
  .contact_wrap {
    flex-direction: column;
  }
  .right_wrap {
    flex: 0 0 auto !important;
  }
}
</style>
